<ion-content [fullscreen]="true">
  <ion-refresher
    id="refresher"
    slot="fixed"
    (ionRefresh)="doRefresh($event)"
    [disabled]="!this.platform.is('capacitor')"
  >
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-grid>
    <ion-row>
      <ion-col>
        <app-info-varsling-popup
          *ngFor="let i = index; let message; of: infoMessages"
          [popupId]="i"
          [message]="message"
        ></app-info-varsling-popup>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-row>
          <ion-col>
            <ion-title>
              <h1>Spotpris</h1>
            </ion-title>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            size="12"
            size-md="8"
            offset-md="2"
            size-lg="4"
            offset-lg="4"
          >
            <div style="text-align: center" class="anleggs-liste-forbruk">
              @if (areaLoading) {
              <ion-spinner name="dots"></ion-spinner>
              } @else {
              <ion-select
                [(ngModel)]="valgtPrisomraade"
                (ngModelChange)="reloadChart()"
                interface="popover"
                justify="space-between"
                labelPlacement="stacked"
                [interfaceOptions]="{
                    header: 'Velg prisområde',
                  }"
                class="w-full md:max-w-full"
              >
                @for (omr of prisomraader; track $index) {
                <ion-select-option [value]="omr">
                  {{omr.friendly}} {{omr.antAnlegg > 0 ? " (" + omr.antAnlegg +
                  (omr.antAnlegg === 1 ? " avtale)" : " avtaler)"): ""}}
                  &nbsp;<ion-icon name="caret-down-outline"></ion-icon>
                </ion-select-option>
                }
              </ion-select>
              }
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>

    <ion-row class="spotpris-container-row">
      <ion-col class="ion-padding" size="12" size-lg="10" offset-lg="1">
        <p class="bg-[var(--success-20)] p-4 my-0 rounded-xl md:mx-3">
          Nedenfor kan du se den faktiske prisen etter strømstøtten ved å klikke
          på
          <strong>"Trekk fra strømstøtte"</strong>. Vi tar forbehold om feil.
        </p>
      </ion-col>
    </ion-row>

    <ion-row class="spotpris-container-row">
      <ion-col class="ion-padding" size="12" size-lg="10" offset-lg="1">
        <ion-row>
          <ion-col class="ion-padding">
            <ion-button
              class="hundred pointer"
              strong="true"
              [style.display]="_chartTypes.Dag.visible ? 'inline-block' : 'none'"
              [class]="_chartTypes.Dag.active ? 'hydrated dark' : 'hydrated'"
              (click)="selectChartType('Dag')"
              ><b>Dag</b></ion-button
            >
          </ion-col>
          <ion-col class="ion-padding">
            <ion-button
              class="hundred pointer"
              strong="true"
              [style.display]="_chartTypes.Time.visible ? 'inline-block' : 'none'"
              [class]="_chartTypes.Time.active ? 'hydrated dark' : 'hydrated'"
              (click)="selectChartType('Time')"
              style="margin-right: 0px"
              ><b>Time</b></ion-button
            >
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="ion-padding">
            <div class="backorforth m-bottom">
              @if (_chartTypes.Aar.active) {
              {{this.minDate.getFullYear()}}-{{this.maxDate.getFullYear()}} }
              @if (_chartTypes.Maaned.active) {
              <table width="100%">
                <tr>
                  <td width="10%" (click)="moveBack('year')">
                    <ion-icon
                      [class]="monthBack ? 'enabledicon hydrated pointer' : 'disabledicon hydrated'"
                      size="medium"
                      name="chevron-back-outline"
                    ></ion-icon>
                  </td>
                  <td width="80%">
                    <span (click)="showHideCal('year')" class="pointer">
                      <ion-icon name="calendar"></ion-icon
                      >&nbsp;{{this.selectedYear | date:'yyyy'}}
                    </span>
                  </td>
                  <td width="10%" (click)="moveForth('year')">
                    <ion-icon
                      [class]="monthForward ? 'enabledicon hydrated pointer' : 'disabledicon hydrated'"
                      name="chevron-forward-outline"
                    ></ion-icon>
                  </td>
                </tr>
              </table>
              } @if (_chartTypes.Dag.active) {
              <table width="100%">
                <tr>
                  <td width="10%" (click)="moveBack('month')">
                    <ion-icon
                      [class]="dayBack ? 'enabledicon hydrated pointer' : 'disabledicon'"
                      size="medium"
                      name="chevron-back-outline"
                    ></ion-icon>
                  </td>
                  <td width="80%">
                    <span (click)="showHideCal('month')" class="pointer">
                      <ion-icon name="calendar"></ion-icon
                      >&nbsp;{{this.selectedMonth | date:'MMMM yyyy':'':'nb' |
                      titlecase}}
                    </span>
                  </td>
                  <td width="10%" (click)="moveForth('month')">
                    <ion-icon
                      [class]="dayForward ? 'enabledicon hydrated pointer' : 'disabledicon hydrated'"
                      name="chevron-forward-outline"
                    ></ion-icon>
                  </td>
                </tr>
              </table>

              } @if (_chartTypes.Time.active) {
              <table width="100%">
                <tr>
                  <td width="10%" (click)="moveBack('day')">
                    <ion-icon
                      [class]="hourBack ? 'enabledicon hydrated pointer' : 'disabledicon hydrated'"
                      size="medium"
                      name="chevron-back-outline"
                    ></ion-icon>
                  </td>
                  <td width="80%">
                    <span (click)="showHideCal('day')" class="pointer">
                      <ion-icon name="calendar"></ion-icon
                      >&nbsp;{{this.selectedDay | date : 'd. MMMM yyyy' : '' :
                      'nb'}}
                    </span>
                  </td>
                  <td width="10%" (click)="moveForth('day')">
                    <ion-icon
                      [class]="hourForward ? 'enabledicon hydrated pointer' : 'disabledicon hydrated'"
                      name="chevron-forward-outline"
                    ></ion-icon>
                  </td>
                </tr>
              </table>
              }
            </div>

            <div
              class="datepicker-popup"
              [style.display]="showMonthCal ? 'inline' : 'none'"
            >
              <div
                style="
                  width: 66vw;
                  margin-left: 14vw;
                  margin-right: 14vw;
                  text-align: match-parent;
                  border: 0px;
                "
              >
                <div class="datepicker-here" id="airspotDay"></div>
              </div>
            </div>
            <div
              class="datepicker-popup"
              [style.display]="showDayCal ? 'inline' : 'none'"
            >
              <div
                style="
                  width: 66vw;
                  margin-left: 14vw;
                  margin-right: 14vw;
                  text-align: match-parent;
                  border: 0px;
                "
              >
                <div class="datepicker-here" id="airspotHour"></div>
              </div>
            </div>
            @if (_chartTypes.Dag.active) {
            <ion-item lines="none">
              <ion-label class="toggle-text">Visning</ion-label>
              <div class="toggle-view-mode">
                <span class="toggle-text" (click)="showTableDay = false"
                  >Stolper</span
                >
                <ion-toggle
                  aria-label="Visning"
                  mode="md"
                  [checked]="showTableDay"
                  (ionChange)="toggleTableDay()"
                ></ion-toggle>
                <span class="ml-10 toggle-text" (click)="showTableDay = true"
                  >Tabell</span
                >
              </div>
            </ion-item>
            <ion-item lines="none" class="pt-2">
              <ion-checkbox
                mode="md"
                labelPlacement="start"
                [checked]="showStromstotte"
                (ionChange)="toggleStromstotte()"
                [disabled]="!hasStotteDay"
                >Trekk fra strømstøtte @if(!hasStotteDay) {
                <span class="text-sm block">
                  Ingen støtte å vise denne måneden
                </span>
                }
              </ion-checkbox>
            </ion-item>
            @if (!hasFetchingError) { @if (areaLoading) {
            <div class="loadingContainer">
              <ion-spinner name="dots"></ion-spinner>
            </div>
            } @else {
            <div
              [ngClass]="{'chart-container-grey mt-3': !showTableDay}"
              class="chart-container"
            >
              @if (prisDagerDay) { @if (!showTableDay) {
              <app-day-spot-chart
                [selectedDate]="selectedMonth"
                [dayPrices]="prisDagerDay"
                [selectedArea]="valgtPrisomraade"
                [extraAreas]="extraPrisomraader"
                [avtaler]="_avtaler"
                [johnEvenFastpris]="isJohnEven ? fastprisJohnEven : undefined"
                [stromstotteData]="hasStotteDay ? stromstotteDay : undefined"
              ></app-day-spot-chart>
              } @else {
              <app-day-spot-table
                [selectedDate]="selectedMonth"
                [dayPrices]="showStromstotte ? stromstotteDay : prisDagerDay"
                [selectedArea]="valgtPrisomraade"
                [avtaler]="_avtaler"
              ></app-day-spot-table>
              } } @else {
              <div class="loadingContainer">
                <ion-spinner name="dots"></ion-spinner>
              </div>
              }
            </div>
            } } @else {
            <div class="chart-container chart-container-grey error">
              <div class="errorMessage">
                <ion-icon name="warning-outline" class="errorIcon"></ion-icon>
              </div>
              <p class="errorMessage">
                Klarte ikke hente data. Prøv igjen senere eller kontakt oss om
                problemet vedvarer.
              </p>
            </div>
            } } @if (_chartTypes.Time.active) {
            <ion-item lines="none">
              <ion-label class="toggle-text">Visning</ion-label>
              <div class="toggle-view-mode">
                <span class="toggle-text" (click)="showTableHour = false"
                  >Stolper</span
                >
                <ion-toggle
                  aria-label="Visning"
                  mode="md"
                  [checked]="showTableHour"
                  (ionChange)="toggleTableHour()"
                ></ion-toggle>
                <span class="ml-10 toggle-text" (click)="showTableHour = true"
                  >Tabell</span
                >
              </div>
            </ion-item>
            <ion-item lines="none" class="pt-2">
              <ion-checkbox
                mode="md"
                labelPlacement="start"
                [checked]="showStromstotte"
                (ionChange)="toggleStromstotte()"
                [disabled]="!hasStotteHour"
                >Trekk fra strømstøtte @if(!hasStotteHour) {
                <span class="text-sm block">
                  Ingen støtte å vise denne dagen
                </span>
                }
              </ion-checkbox>
            </ion-item>
            @if (!hasFetchingError) {
            <div
              [ngClass]="{'chart-container-grey mt-3': !showTableHour}"
              class="chart-container"
            >
              @if (prisDagerHour) { @if (!showTableHour) {
              <app-hour-spot-chart
                [selectedDate]="selectedDay"
                [dayPrices]="prisDagerHour"
                [selectedArea]="valgtPrisomraade"
                [extraAreas]="extraPrisomraader"
                [avtaler]="_avtaler"
                [stromstotteData]="hasStotteHour ? stromstotteHour : undefined"
              ></app-hour-spot-chart>
              } @else {
              <app-hour-spot-table
                [selectedDate]="selectedDay"
                [dayPrices]="showStromstotte ? stromstotteHour : prisDagerHour"
                [selectedArea]="valgtPrisomraade"
                [avtaler]="_avtaler"
              >
              </app-hour-spot-table>
              } } @else {
              <div class="loadingContainer">
                <ion-spinner name="dots"></ion-spinner>
              </div>
              }
            </div>
            } @else {
            <div class="chart-container chart-container-grey error">
              <div class="errorMessage">
                <ion-icon name="warning-outline" class="errorIcon"></ion-icon>
              </div>
              <p class="errorMessage">
                Klarte ikke hente data. Prøv igjen senere eller kontakt oss om
                problemet vedvarer.
              </p>
            </div>
            } }
          </ion-col>
        </ion-row>
      </ion-col>

      <ion-col class="ion-padding" size="12" size-lg="10" offset-lg="1">
        @if (!(_chartTypes.Dag.active && showTableDay ||
        (_chartTypes.Time.active && showTableHour))) {
        <p class="priceomr_undertittel">Sammenlign med andre prisområder</p>
        } @if (!(_chartTypes.Dag.active && showTableDay ||
        (_chartTypes.Time.active && showTableHour))) {
        <ion-row>
          <ion-col
            sizeSm="6"
            sizeMd="auto"
            class="ion-padding"
            [hidden]="valgtPrisomraade.omraade==='NO1'"
            ><ion-button
              [disabled]="valgtPrisomraade.omraade==='NO1'"
              strong="true"
              class="whitespace-nowrap"
              [ngClass]="{hydrated: true, wide: true, selected: extraPrisomraader[0].valgt}"
              (click)="selectAdditionalOmraade(0)"
              >{{prisomraader[0].friendly}}</ion-button
            ></ion-col
          >
          <ion-col
            sizeSm="6"
            sizeMd="auto"
            class="ion-padding"
            [hidden]="valgtPrisomraade.omraade==='NO2'"
            ><ion-button
              [disabled]="valgtPrisomraade.omraade==='NO2'"
              strong="true"
              class="whitespace-nowrap"
              [ngClass]="{hydrated: true, wide: true, selected: extraPrisomraader[1].valgt}"
              (click)="selectAdditionalOmraade(1)"
              >{{prisomraader[1].friendly}}</ion-button
            ></ion-col
          >
          <ion-col
            sizeSm="6"
            sizeMd="auto"
            class="ion-padding"
            [hidden]="valgtPrisomraade.omraade==='NO3'"
            ><ion-button
              [disabled]="valgtPrisomraade.omraade==='NO3'"
              strong="true"
              class="whitespace-nowrap"
              [ngClass]="{hydrated: true, wide: true, selected: extraPrisomraader[2].valgt}"
              (click)="selectAdditionalOmraade(2)"
              >{{prisomraader[2].friendly}}</ion-button
            ></ion-col
          >
          <ion-col
            sizeSm="6"
            sizeMd="auto"
            class="ion-padding"
            [hidden]="valgtPrisomraade.omraade==='NO4'"
            ><ion-button
              [disabled]="valgtPrisomraade.omraade==='NO4'"
              strong="true"
              class="whitespace-nowrap"
              [ngClass]="{hydrated: true, wide: true, selected: extraPrisomraader[3].valgt}"
              (click)="selectAdditionalOmraade(3)"
              >{{prisomraader[3].friendly}}</ion-button
            ></ion-col
          >
          <ion-col
            sizeSm="6"
            sizeMd="auto"
            class="ion-padding"
            [hidden]="valgtPrisomraade.omraade==='NO5'"
            ><ion-button
              [disabled]="valgtPrisomraade.omraade==='NO5'"
              strong="true"
              class="whitespace-nowrap"
              [ngClass]="{hydrated: true, wide: true, selected: extraPrisomraader[4].valgt}"
              (click)="selectAdditionalOmraade(4)"
              >{{prisomraader[4].friendly}}</ion-button
            ></ion-col
          >
        </ion-row>
        } @if (aboutAreas) {
        <ion-row>
          <ion-col class="ion-padding" size="10" offset="0">
            <div class="abouttext">
              <p class="bold">
                {{aboutAreas.title}}<ion-icon
                  name="information-circle-outline"
                  class="ml-2 cursor-pointer"
                  (click)="expandAreaTooltip()"
                ></ion-icon>
              </p>
              <p>{{aboutAreas.description}}</p>
            </div>
          </ion-col>
        </ion-row>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
  <app-feedback></app-feedback>
  <div class="tab-content-bottom-margin"></div>
</ion-content>
